// Libs
import axios from 'axios'

// Axios
import { searchAPI } from '../../index'

// Action types
export const TOGGLE_SEARCH = 'toggle_search'
export const TOGGLE_SEARCH_FIELD = 'toggle_search_field'
export const CHANGE_SEARCH_LOADING = 'change_search_loading'
export const CHANGE_SEARCH_LOADING_MORE = 'change_search_loading_more'
export const CHANGE_SEARCH_VALUE = 'change_search_value'
export const CHANGE_SEARCH_FIELDS = 'change_search_fields'
export const CHANGE_SEARCH_RESULTS = 'change_search_results'
export const CHANGE_SEARCH_PAGINATION = 'change_search_pagination'

export let searchCancel


export const toggleSearch = () => {
  return {
    type: TOGGLE_SEARCH
  }
}

export const toggleSearchField = (field) => {
  return {
    type: TOGGLE_SEARCH_FIELD,
    payload: field
  }
}

export const changeSearchLoading = (status) => {
  return {
    type: CHANGE_SEARCH_LOADING,
    payload: status
  }
}


export const changeSearchLoadingMore = (status) => {
  return {
    type: CHANGE_SEARCH_LOADING_MORE,
    payload: status
  }
}

export const changeSearchValue = (value) => {
  return {
    type: CHANGE_SEARCH_VALUE,
    payload: value
  }
}

export const changeSearchFields = (fields) => {
  return {
    type: CHANGE_SEARCH_FIELDS,
    payload: fields
  }
}

export const changeSearchResults = (results, from) => {
  return {
    type: CHANGE_SEARCH_RESULTS,
    payload: {
      results,
      from
    }
  }
}

export const changeSearchPagination = (pagination) => {
  return {
    type: CHANGE_SEARCH_PAGINATION,
    payload: pagination
  }
}

export const search = (value, from, size, fields) => {
  searchCancel && searchCancel()

  let config = {
    cancelToken: new axios.CancelToken(function executor(c) {
      searchCancel = c;
    })
  }

  return dispatch => {
    from === 0 ?
      dispatch(changeSearchLoading(true)) :
      dispatch(changeSearchLoadingMore(true))
    console.log({ value, from, size, fields })
    searchAPI.post('/', { value, from, size, fields }, config)
      .then(response => {
        from === 0 ?
          dispatch(changeSearchLoading(false)) :
          dispatch(changeSearchLoadingMore(false))

        if (value) {
          let total = response.data.hits.total.value

          dispatch(changeSearchResults(response.data.hits.hits, from))
          dispatch(changeSearchPagination({ total, from: from + size, size }))
        } else {
          dispatch(changeSearchResults([], 0))
          dispatch(changeSearchPagination({ total: 0, from: 0, size: 15 }))
        }

      })
      .catch(e => {
        if (!axios.isCancel(e)) {
          from === 0 ?
            dispatch(changeSearchLoading(false)) :
            dispatch(changeSearchLoadingMore(false))
        }
      })
  }
}
